export { default } from "./useGetStudent";
